"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as t } from "../../../utils/styles.mjs";
import { Text as n } from "../Text/Text.mjs";
import { forwardRef as r, useState as i } from "react";
import { twMerge as a } from "tailwind-merge";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { cva as c } from "class-variance-authority";
//#region src/components/atoms/Button/Button.tsx
var l = c(`
    px-6
    rounded-sm
    ${t()}
    cursor-pointer
    text-center
    border-transparent
    border-2
    flex
    items-center
    justify-center
    gap-x-2
    w-full
`, {
	variants: {
		variant: {
			primary: "bg-yellow-400 hover:bg-yellow-600 text-gray-900",
			secondary: "bg-gray-800 hover:bg-gray-900 text-white",
			"outlined-dark": "border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white",
			"outlined-light": "border-white text-white hover:text-gray-800 hover:bg-white hover:border-gray-800",
			"outlined-gradient": "border-transparent text-white",
			text: "bg-transparent text-blue-700 hover:bg-gray-100 hover:text-blue-800",
			alternate: "bg-blue-700 hover:bg-blue-800 text-white"
		},
		size: {
			default: "py-1-5 min-h-[40px]",
			large: "py-3 min-h-[56px]"
		},
		disabled: { true: "bg-gray-200 text-gray-500 border-gray-200 hover:border-gray-200 focus:outline-none hover:bg-gray-200 hover:text-gray-500 cursor-not-allowed" },
		isLink: { true: "inline-flex items-center" }
	},
	defaultVariants: {
		variant: "primary",
		size: "default"
	}
}), u = c("w-4 h-4 fill-current hover:fill-current", { variants: {
	variant: {
		primary: "fill-current hover:fill-current",
		secondary: "fill-white hover:fill-gray-900",
		"outlined-dark": "fill-gray-800 hover:fill-white",
		"outlined-light": "fill-current hover:fill-current",
		"outlined-gradient": "fill-current hover:fill-current",
		text: "fill-current hover:fill-current",
		alternate: "fill-white hover:fill-gray-200"
	},
	disabled: { true: "fill-gray-500 hover:fill-gray-500" }
} }), d = "bg-conic-225 from-amethyst-500 from-0% via-bubblegum-500 to-amethyst-500", f = "bg-[conic-gradient(transparent_0deg,transparent_270deg,var(--color-amethyst-500)_300deg,var(--color-orange-100)_330deg,var(--color-bubblegum-500)_345deg,transparent_360deg)]", p = "transition-opacity duration-300", m = ({ animated: t }) => /* @__PURE__ */ o("span", {
	"aria-hidden": "true",
	className: e("pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden rounded-sm p-0-5", "mask-[linear-gradient(black,black),linear-gradient(black,black)] [mask-clip:content-box,border-box] mask-exclude"),
	children: /* @__PURE__ */ s("span", {
		className: "relative aspect-square w-[200%] shrink-0",
		children: [t && /* @__PURE__ */ o("span", { className: e("absolute inset-0", f, p, "animate-[spin_3s_linear_infinite] group-hover/gradient-border:opacity-0", "motion-reduce:hidden") }), /* @__PURE__ */ o("span", { className: e("absolute inset-0", d, t && e(p, "opacity-0 group-hover/gradient-border:opacity-100 motion-reduce:opacity-100")) })]
	})
}), h = r(({ children: t, variant: r, className: c = "", buttonClassName: d = "", size: f = "default", disabled: p = !1, animatedBorder: h = !1, href: g, iconPrefix: _, iconSuffix: v, onFocus: y, onBlur: b, ...x }, S) => {
	let C = f === "large" ? "base" : "sm", [w, T] = i(!1), E = (e) => {
		e.currentTarget.matches(":focus-visible") && T(!0), y?.(e);
	}, D = (e) => {
		T(!1), b?.(e);
	}, O = r === "outlined-gradient" && !p, k;
	return k = g && !p ? /* @__PURE__ */ s("a", {
		...x,
		ref: S,
		className: e(l({
			variant: r,
			size: f,
			disabled: p,
			isLink: !0
		}), d),
		href: g,
		onFocus: E,
		onBlur: D,
		children: [_ && /* @__PURE__ */ o("div", {
			className: e(u({
				variant: r,
				disabled: p
			})),
			children: _
		}), /* @__PURE__ */ o(n, {
			asChild: !0,
			fontSize: C,
			children: /* @__PURE__ */ o("span", { children: t })
		})]
	}) : /* @__PURE__ */ s("button", {
		...x,
		ref: S,
		className: e(l({
			variant: r,
			size: f,
			disabled: p
		}), d),
		disabled: p,
		onFocus: E,
		onBlur: D,
		children: [
			_ && /* @__PURE__ */ o("div", {
				className: e(u({
					variant: r,
					disabled: p
				})),
				children: _
			}),
			/* @__PURE__ */ o(n, {
				asChild: !0,
				fontSize: C,
				children: /* @__PURE__ */ o("span", { children: t })
			}),
			v && /* @__PURE__ */ o("div", {
				className: e(u({
					variant: r,
					disabled: p
				})),
				children: v
			})
		]
	}), /* @__PURE__ */ s("div", {
		className: a("inline-block rounded-sm w-auto", O && "relative group/gradient-border", w && "focus-within:outline-2 focus-within:outline-white focus-within:outline-offset-2", c),
		children: [O && /* @__PURE__ */ o(m, { animated: h }), k]
	});
});
h.displayName = "Button";
//#endregion
export { h as Button };
